import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes, NotificationTemplateEnum } from '@finxone-platform/shared/sys-config-types';

export const beneficiarySmsTranslations = {
  [Locale.en_GB]: {
    ADD_BENEFICIARY_TITLE: 'A new beneficiary has been added to your account: {{beneficiaryName}}',
    ADD_BENEFICIARY_DESCRIPTION: '',
    UPDATE_BENEFICIARY_TITLE: "The beneficiary {{beneficiaryName}}'s details were updated",
    UPDATE_BENEFICIARY_DESCRIPTION: '',
    REMOVE_BENEFICIARY_TITLE: 'The beneficiary {{beneficiaryName}} has been removed from your account',
    REMOVE_BENEFICIARY_DESCRIPTION: '',
  },
  // Add more locales as needed
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateBeneficiarySmsAlerts = (translations: any) => ({
  [NotificationTemplateEnum.ADD_BENEFICIARY]: {
    name: 'Add Beneficiary',
    type: AlertTypes.INFO,
    title: translations.ADD_BENEFICIARY_TITLE,
    description: translations.ADD_BENEFICIARY_DESCRIPTION,
  },
  [NotificationTemplateEnum.UPDATE_BENEFICIARY]: {
    name: 'Update Beneficiary',
    type: AlertTypes.INFO,
    title: translations.UPDATE_BENEFICIARY_TITLE,
    description: translations.UPDATE_BENEFICIARY_DESCRIPTION,
  },
  [NotificationTemplateEnum.REMOVE_BENEFICIARY]: {
    name: 'Remove Beneficiary',
    type: AlertTypes.INFO,
    title: translations.REMOVE_BENEFICIARY_TITLE,
    description: translations.REMOVE_BENEFICIARY_DESCRIPTION,
  },
});
